import Login from './components/Login.vue'
import Dashboard from './components/Dashboard.vue'
import DashboardIndex from './components/modules/dashboard/Index.vue'
import DashboardShow from './components/modules/dashboard/Show.vue'
import DashboardCreate from './components/modules/dashboard/Create.vue'
import NotFound from './components/modules/dashboard/404.vue'
import Register from './components/Register.vue'

// Routes
const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: (to, from, next) => {
      document.body.className = 'login-page'
      next()
    }
  }, {
    path: '/register',
    name: 'register',
    component: Register,
    beforeEnter: (to, from, next) => {
      document.body.className = 'login-page'
      next()
    }
  }, {
    path: '/',
    component: Dashboard,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      document.body.className += ' skin-blue sidebar-mini'
      next()
    },
    activate: function () {
      this.$nextTick(function () {
        // => 'DOM loaded and ready'
      })
    },
    children: [
      {
        path: '',
        redirect: '/concerts'
      }, {
        path: '/concerts',
        name: 'dashboard',
        component: DashboardIndex
      }, {
        path: '*',
        name: '404',
        component: NotFound
      }, {
        path: '/concerts/:id',
        component: DashboardShow,
        name: 'concerts.show'
      }, {
        path: '/concerts/create',
        component: DashboardCreate,
        name: 'concerts.create'
      }, {
        path: '/concerts/:id/edit',
        component: DashboardCreate,
        name: 'concerts.edit'
      }
    ]
  }, {
    // not found handler
    path: '*',
    redirect: '/login'
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js